import { gql, TypedDocumentNode } from "@apollo/client";

import { QuerySearchRepoFilesSuggestionsArgs, SearchSuggestionsOutput } from "types/generated";

export const SEARCH_SPACELIFT_VCS_FILES_SUGGESTIONS: TypedDocumentNode<
  { searchRepoFilesSuggestions: Pick<SearchSuggestionsOutput, "filteredCount"> },
  QuerySearchRepoFilesSuggestionsArgs
> = gql`
  query SearchSpaceliftVcsFilesSuggestions($repoID: ID!, $input: SearchSuggestionsInput!) {
    searchRepoFilesSuggestions(repoID: $repoID, input: $input) {
      filteredCount
    }
  }
`;
